import { WBIcon, WBIconButton } from '@admiin-com/ds-web';
import { useLocation } from 'react-router-dom';
import { PATHS } from '../../navigation/paths';

interface BackButtonProps {
  onClick: () => void;
}

export const BackButton = (props: BackButtonProps) => {
  const { pathname } = useLocation();
  const isShown =
    pathname !== PATHS.onboardingComplete && pathname !== PATHS.onboardingName;

  return isShown ? (
    <WBIconButton
      sx={{
        top: 35,
        left: 25,
        position: 'absolute',
        backgroundColor: 'transparent',
      }}
      onClick={() => props.onClick()}
    >
      <WBIcon name="ArrowBack" size={'small'} />
    </WBIconButton>
  ) : null;
};
